var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('esg-table-without-meta',{attrs:{"items":_vm.items,"fields":_vm.fields,"striped":false,"max-height":"450px","size":"xs"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }